import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@klickdata/core/auth';
import { MediaType } from '@klickdata/core/media/src/media-type';
import { Media } from '@klickdata/core/media/src/media.model';
import { MediaService } from '@klickdata/core/media/src/media.service';
import { PlayerMediaViewComponent } from '@klickdata/core/media/src/player-media-view/player-media-view.component';
import { ResourceItem } from '@klickdata/core/resource-item';
import { User } from '@klickdata/core/user';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-dialog-display-material-item',
    templateUrl: './dialog-display-material-item.component.html',
    styleUrls: ['./dialog-display-material-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogDisplayMaterialItemComponent extends OnDestroyHandler implements OnInit {
    @ViewChild(PlayerMediaViewComponent) mediaView: PlayerMediaViewComponent;
    currentIndex: number = 0;
    public authUser$: Observable<User>;
    public materialWithOptions: boolean;
    public currentMedia: Media;
    public nextBtnClickedInPDF: boolean;
    MediaType = MediaType;
    constructor(
        public dialogRef: MatDialogRef<DialogDisplayMaterialItemComponent>,
        @Inject(MAT_DIALOG_DATA) public items: any[],
        protected mediaService: MediaService,
        private cd: ChangeDetectorRef,
        private authService: AuthService
    ) {
        super();
    }

    ngOnInit(): void {
        this.authUser$ = this.authService.getUser();
        if (!!this.items.length) {
            this.items = this.items.map((item) => new ResourceItem(item));
            this.items.forEach((item) => {
                if (!item.item_type_value?.toLowerCase().includes('text')) {
                    item.media$ = this.mediaService.getMediaByResourceItemId(item.id);
                }
            });
        }
    }
    onMediaUpdated(media: Media) {
        this.currentMedia = media;
        this.materialWithOptions =
            media.mediaType == MediaType.VIDEO ||
            media.mediaType == MediaType.PDF ||
            media.mediaType == MediaType.URL ||
            media.mediaType == MediaType.AUDIO ||
            media.mediaType == MediaType.LINK;
        this.cd.markForCheck();
    }
    public openInNewTab() {
        window.open(this.currentMedia.url || this.currentMedia.src, '_blank');
    }
}
